import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconIntersectionPointsSizeS from './IconIntersectionPoints_size_s';

const props: CreateIconArguments = {
  l: IconIntersectionPointsSizeS,
  m: IconIntersectionPointsSizeS,
  s: IconIntersectionPointsSizeS,
  xs: IconIntersectionPointsSizeS,
  name: 'IconIntersectionPoints',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
